import React, { useEffect } from 'react';
import {
  initMercadoPago,
  CardPayment as MPCardPayment,
} from '@mercadopago/sdk-react';

import {
  aMeses,
  formatNumber,
  renderDeliveryDates,
  renderPickupMessage,
} from '../../../middleware/common-functions';
import { BranchItem } from '../../../models/branch_model';
import {
  OrderResumeProps,
  CardIconProps,
  MonthlyProps,
  Totals,
} from '../../../models/checkout_model';
import { UserDeliveryData, UserType } from '../../../models/user_model';
import {
  ICardPaymentBrickPayer,
  ICardPaymentFormData,
} from '@mercadopago/sdk-react/bricks/cardPayment/type';
import axios from '../../../middleware/axios';
import { updateCart, logPaymentError } from '../../../middleware/cartFunctions';
initMercadoPago(process.env.REACT_APP_MP_KEY!);

////test cards
// Mastercard
// 5474 9254 3267 0366
// 123
// 11/30
// Visa
// 4075 5957 1648 3764
// 123
// 11/30
// American Express
// 3743 781877 55283
// 1234
// 11/30

const OrderResume: React.FC<OrderResumeProps> = ({
  delivery_type,
  selectedBranch,
  branch_data,
  updateSection,
  deliveryData,
  error_message,
  shippingcost,
  payment_type,
  totals,
  user,
  payload,
  placeOrder,
  setOrderObject,
  setError_message,
  setPlacing_order_state,
  pickupMsg,
}) => {
  let delivery_text;

  if (delivery_type === 'shipping') {
    delivery_text = (
      <span>
        {deliveryData.name} {deliveryData.lastname} | {deliveryData.address}{' '}
        <br /> {deliveryData.city} {deliveryData.state} <br />
        {deliveryData.zip}
      </span>
    );
  } else {
    const branch: BranchItem | undefined = branch_data!.xiams.find(
      (i) => i.id == selectedBranch
    );
    delivery_text = (
      <span>
        {branch?.address} <br />
        {branch?.descrp} <br /> {branch_data?.idzalm}{' '}
      </span>
    );
  }
  return (
    <div className="col-md-8 order_resume my-4">
      {error_message && (
        <div className="alert alert-danger d-md-none" id="alert-shake">
          <i className="fas fa-exclamation-circle mr-2"></i>
          {error_message}
        </div>
      )}
      <h5>Forma de Pago</h5>
      {payment_type === 'online' ? (
        <CardPayment
          setError_message={setError_message}
          totals={totals}
          user={user}
          deliveryData={deliveryData}
          onSuccess={placeOrder}
          setOrderObject={setOrderObject}
          setPlacing_order_state={setPlacing_order_state}
        />
      ) : (
        <CardIcon
          icon={
            payment_type === 'rappi'
              ? 'fas fa-mobile-alt'
              : payment_type === 'atrato'
                ? 'fas fa-wallet'
                : payment_type === 'mp_wallet'
                  ? 'fas fa-wallet'
                  : 'fas fa-money-check-alt'
          }
          title={
            payment_type === 'rappi'
              ? 'Pago con RappiPay'
              : payment_type === 'coppel'
                ? 'Pago con Coppel Pay'
                : payment_type === 'atrato'
                  ? 'Pago con Atrato Pago'
                  : payment_type === 'mp_wallet'
                    ? 'Pago con Mercado Pago'
                    : 'Transferencia Electrónica'
          }
          desc={
            payment_type === 'rappi'
              ? 'Podrás completar el pago desde tu app de Rappi'
              : payment_type === 'atrato'
                ? 'Podrás financiar esta compra hasta en 18 cómodas mensualidades, sin necesidad de tener tarjeta de crédito. Después de dar clic en "confirmar pedido", se te dirigirá a Atrato Pago para continuar con tu proceso de compra.'
                : payment_type === 'mp_wallet'
                  ? 'Serás redirigido a Mercado Pago para completar tu pago de forma segura.'
                  : ''
          }
          cta="Modificar"
          section="payment"
          clickFun={updateSection}
        />
      )}

      <h5>Detalles de Entrega</h5>
      <CardIcon
        icon={
          delivery_type === 'shipping'
            ? 'fas fa-shipping-fast'
            : 'fas fa-map-marker-alt'
        }
        title={
          delivery_type === 'shipping'
            ? 'Envío a Domicilio'
            : 'Recoger en Sucursal'
        }
        desc={delivery_text}
        cta="Cambiar"
        section="delivery"
        clickFun={updateSection}
      />
      <CardIcon
        icon="fas fa-stopwatch"
        title="Tiempo de Entrega"
        desc={
          delivery_type === 'pickup'
            ? renderPickupMessage(pickupMsg)
            : renderDeliveryDates(shippingcost.shippingCosts)
        }
      />

      {error_message && (
        <div className="alert alert-danger d-md-none" id="alert-shake">
          <i className="fas fa-exclamation-circle mr-2"></i>
          {error_message}
        </div>
      )}

      <small className="text-help mt-2 d-block text-muted">
        Necesitas ayuda con tu pedido o tienes dudas? <br />
        Estámos para atenderte en el correo <b>servicio@mathasa.com.mx</b> o al
        teléfono <b>614-442-9000</b>
      </small>
      {payload && <FromSecure payload={payload} />}
    </div>
  );
};

export const CardIcon: React.FC<CardIconProps> = ({
  icon,
  title,
  desc,
  cta,
  section,
  clickFun,
  size,
}) => (
  <div className={`card card_icon w-100 mb-4 ${size}`}>
    <div className="card-body">
      <div className="row jus">
        <div className="col-md-2">
          <div className="icon_rounded white">
            <i className={icon}></i>
          </div>
        </div>
        <div className="col-md-7">
          <p>{title}</p>
          <small>{desc}</small>
        </div>
        <div className="col-md-3 d-flex justify-content-end align-items-center">
          <button
            className="btn btn-link text-capitalize text-blue btn-sm btn-block"
            onClick={clickFun}
            data-next={section}
          >
            {cta}
          </button>
        </div>
      </div>
    </div>
  </div>
);

const Monthly: React.FC<MonthlyProps> = ({ meses, total, handleMonths }) => {
  return (
    <div className="mb-3 ">
      <h5>Plazo para Pagos</h5>
      <select
        className="form-control"
        onChange={handleMonths}
        disabled={total < 1500}
      >
        <option value="1">Un solo pago a ${formatNumber(total)}</option>
        {total < 1500 ? (
          <option value="1">
            Hey! no le ande moviendo a páginas que no son suyas. Ya lo vi
          </option>
        ) : (
          meses.map((item, key) => {
            const { monthly_pay, total_pay } = aMeses(total, item);
            return (
              <option value={item.meses} key={`pagos_meses_${key}`}>
                {item.meses} Meses, pagas al mes ${monthly_pay} (Total $
                {total_pay})
              </option>
            );
          })
        )}
      </select>
      <div
        className={`alert-${total >= 1500 ? 'success' : 'warning'} mt-1 p-3`}
      >
        <p className="m-0">
          {total >= 1500
            ? 'Tarjetas BBVA solo se puede pago en 1 sola exhibición'
            : 'Pago a meses sólo dispoible en compras mayores a $1,500'}
        </p>
      </div>
    </div>
  );
};

const FromSecure = ({ payload }: { payload: any }) => {
  if (payload.cReq) {
    return (
      <form action={payload.acsURL} method="POST" id="payload_3d_secure">
        <input type="hidden" name="TermUrl" value={payload.termURL} />
        <input type="hidden" name="creq" value={payload.cReq} />
        <input
          type="hidden"
          name="threeDSSessionData"
          value={payload.sessionData || ''}
        />
      </form>
    );
  } else if (payload.methodForm) {
    return <IframeComponent methodForm={payload.methodForm} />;
  } else {
    return null;
  }
};

type IframeComponentProps = {
  methodForm: string;
};
const IframeComponent: React.FC<IframeComponentProps> = ({ methodForm }) => {
  useEffect(() => {
    ///add methodForm to the DOM
    const div = document.getElementById('fiserv_iframe') as HTMLDivElement;
    div.innerHTML = methodForm;
    setTimeout(() => {
      //@ts-ignore
      document.getElementById('tdsMmethodForm')!.submit();
    }, 2000);
  }, []);
  // Convert escaped HTML characters back to their original form

  return <div id="fiserv_iframe" />;
};

type CardPaymentProps = {
  totals: Totals;
  user: UserType;
  deliveryData: UserDeliveryData;
  onSuccess: any;
  setError_message: any;
  setOrderObject: any;
  setPlacing_order_state: (state: string) => void;
};
const CardPayment: React.FC<CardPaymentProps> = ({
  totals,
  user,
  deliveryData,
  onSuccess,
  setError_message,
  setOrderObject,
  setPlacing_order_state,
}) => {
  const isSubmittingRef = React.useRef(false);

  useEffect(() => {
    return () => {
      // Clean up the controller when the component unmounts
      ///@ts-ignore next-line
      window.cardPaymentBrickController.unmount();
    };
  }, []);

  const onSubmit = async (
    param: ICardPaymentFormData<ICardPaymentBrickPayer>
  ): Promise<void> => {
    //@ts-ignore
    // callback called when clicking the submit data button
    return new Promise(async (resolve, reject) => {
      if (isSubmittingRef.current) return reject(void 0);
      isSubmittingRef.current = true;
      try {
        const response = await axios.post('/scriptsPaymentsMpMakePaymentV2', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: { ...param, user_id: user.id, deliveryData },
        });
        if (response.data.error) {
          setError_message(response.data.message);
          logPaymentError(
            response.data.message || 'mp_payment_error',
            'pago online'
          );
          if (typeof window.dataLayer != 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'payment_attempt',
              event_category: 'Ecommerce',
              event_label: response.data.message,
              payment_method: 'online',
            });
          }
          return reject(void 0);
        }

        // Handle 3DS authentication required
        if (response.data.requires_3ds && response.data.three_ds_info) {
          const { three_ds_info } = response.data;

          // Store payment ID in sessionStorage to retrieve after 3DS redirect
          sessionStorage.setItem('mp_pending_payment_id', response.data.id);
          sessionStorage.setItem(
            'mp_payment_method_id',
            response.data.payment_method_id
          );

          console.log(
            '3DS authentication required',
            'External URL:',
            three_ds_info.external_resource_url,
            'Has creq:',
            !!three_ds_info.creq
          );

          // Redirect to 3DS authentication URL using window.open in a new tab
          if (three_ds_info.external_resource_url) {
            // Open in same window to maintain session
            var iframe = document.createElement('iframe');
            iframe.name = 'MP_3DS';
            iframe.id = 'MP_3DS';
            iframe.style.cssText = `
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 90%;
              max-width: 500px;
              height: 600px;
              border: none;
              border-radius: 8px;
              box-shadow: 0 4px 20px rgba(0,0,0,0.3);
              z-index: 10001;
            `;

            // Create backdrop
            const backdrop = document.createElement('div');
            backdrop.id = 'MP_3DS_backdrop';
            backdrop.style.cssText = `
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(255, 255, 255, 0.95);
              z-index: 10000;
              display: flex;
              align-items: center;
              justify-content: center;
            `;

            document.body.appendChild(backdrop);
            backdrop.appendChild(iframe);

            // Add message event listener to handle 3DS completion
            const handleMessage = async (e: MessageEvent) => {
              console.log('3DS Message received:', e.data);

              if (
                e.data.status === 'COMPLETE' ||
                e.data.status === 'approved'
              ) {
                // Remove event listener
                window.removeEventListener('message', handleMessage);

                // Remove iframe and backdrop
                const backdropElement =
                  document.getElementById('MP_3DS_backdrop');
                if (backdropElement) {
                  backdropElement.remove();
                }

                // Show verifying feedback
                setError_message(null);
                setPlacing_order_state('paying_3d');

                // Verify payment status with backend (with delay and retries)
                const pendingPaymentId = sessionStorage.getItem(
                  'mp_pending_payment_id'
                );
                if (pendingPaymentId) {
                  const maxRetries = 3;
                  let attempt = 0;

                  // Wait 4 seconds before first attempt
                  await new Promise((resolve) => setTimeout(resolve, 4000));

                  while (attempt < maxRetries) {
                    try {
                      // Update user feedback
                      setError_message(null);
                      setPlacing_order_state('paying_3d');
                      console.log(
                        `Verification attempt ${attempt + 1} of ${maxRetries}`
                      );

                      const verifyResponse = await axios.post(
                        '/scriptsPaymentsMpVerifyPayment',
                        {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                          },
                          body: { payment_id: pendingPaymentId },
                        }
                      );

                      if (verifyResponse.data.error) {
                        // Clear sessionStorage and show error
                        sessionStorage.removeItem('mp_pending_payment_id');
                        sessionStorage.removeItem('mp_payment_method_id');
                        setPlacing_order_state('');
                        setError_message(
                          verifyResponse.data.message ||
                            'Error al verificar el pago'
                        );
                        logPaymentError(
                          verifyResponse.data.message ||
                            'mp_3ds_inline_verify_error',
                          'online'
                        );
                        if (typeof window.dataLayer != 'undefined') {
                          window.dataLayer.push({
                            event: 'payment_attempt',
                            event_category: 'Ecommerce',
                            event_label:
                              verifyResponse.data.message ||
                              'Error al verificar el pago',
                            payment_method: 'online',
                          });
                        }
                        return reject(void 0);
                      }
                      console.log({ verifyResponse });
                      debugger;
                      if (
                        verifyResponse.data.success &&
                        verifyResponse.data.status === 'approved'
                      ) {
                        // Payment was approved after 3DS authentication
                        sessionStorage.removeItem('mp_pending_payment_id');
                        sessionStorage.removeItem('mp_payment_method_id');

                        const order_obj = setOrderObject();
                        order_obj.mp_payment = {
                          authorization_code:
                            verifyResponse.data.authorization_code,
                          card: verifyResponse.data.card.last_four_digits,
                        };
                        order_obj.meses = verifyResponse.data.installments;
                        order_obj.ipgTransactionId = verifyResponse.data.id;

                        onSuccess(false, order_obj);
                        return resolve(void 0);
                      } else if (verifyResponse.data.status === 'pending') {
                        // Payment still pending, retry if we have attempts left
                        attempt++;
                        if (attempt < maxRetries) {
                          console.log(
                            `Payment still pending, waiting 4 seconds before retry...`
                          );
                          setPlacing_order_state('paying_3d');
                          await new Promise((resolve) =>
                            setTimeout(resolve, 4000)
                          );
                        } else {
                          // Max retries reached, show error
                          sessionStorage.removeItem('mp_pending_payment_id');
                          sessionStorage.removeItem('mp_payment_method_id');
                          setPlacing_order_state('');
                          setError_message(
                            'El pago está pendiente de confirmación. Por favor verifica tu cuenta o intenta de nuevo.'
                          );
                          logPaymentError('mp_3ds_max_retries', 'pago online');
                          if (typeof window.dataLayer != 'undefined') {
                            window.dataLayer.push({
                              event: 'payment_attempt',
                              event_category: 'Ecommerce',
                              event_label:
                                'Pago pendiente - máximo de reintentos alcanzado',
                              payment_method: 'online',
                            });
                          }
                          return reject(void 0);
                        }
                      } else {
                        // Other status (rejected, etc.)
                        sessionStorage.removeItem('mp_pending_payment_id');
                        sessionStorage.removeItem('mp_payment_method_id');
                        setPlacing_order_state('');
                        setError_message(
                          verifyResponse.data.message ||
                            'El pago no pudo ser completado'
                        );
                        logPaymentError(
                          verifyResponse.data.message ||
                            `mp_3ds_status_${verifyResponse.data.status || 'unknown'}`,
                          'online'
                        );
                        if (typeof window.dataLayer != 'undefined') {
                          window.dataLayer.push({
                            event: 'payment_attempt',
                            event_category: 'Ecommerce',
                            event_label:
                              verifyResponse.data.message ||
                              'El pago no pudo ser completado',
                            payment_method: 'online',
                          });
                        }
                        return reject(void 0);
                      }
                    } catch (error) {
                      console.error('Error verifying 3DS payment:', error);
                      sessionStorage.removeItem('mp_pending_payment_id');
                      sessionStorage.removeItem('mp_payment_method_id');
                      setPlacing_order_state('');
                      setError_message('Error al verificar el estado del pago');
                      if (typeof window.dataLayer != 'undefined') {
                        window.dataLayer.push({
                          event: 'payment_attempt',
                          event_category: 'Ecommerce',
                          event_label: 'Error al verificar el estado del pago',
                          payment_method: 'online',
                        });
                      }
                      return reject(void 0);
                    }
                  }
                }
              }
            };

            window.addEventListener('message', handleMessage);

            const form = document.createElement('form');
            form.name = 'myform';
            form.setAttribute('target', 'MP_3DS');
            form.setAttribute('method', 'post');
            form.setAttribute('action', three_ds_info.external_resource_url);

            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', 'creq');
            hiddenField.setAttribute('value', three_ds_info.creq);
            form.appendChild(hiddenField);
            iframe.appendChild(form);

            form.submit();
          } else if (three_ds_info.creq && three_ds_info.acs_url) {
            // Handle challenge request form submission
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = three_ds_info.acs_url;
            form.style.display = 'none';

            const inputCreq = document.createElement('input');
            inputCreq.type = 'hidden';
            inputCreq.name = 'creq';
            inputCreq.value = three_ds_info.creq;
            form.appendChild(inputCreq);

            document.body.appendChild(form);
            form.submit();
          } else {
            // Fallback error
            console.error('3DS info incomplete:', three_ds_info);
            setError_message(
              'Error al iniciar autenticación 3DS. Por favor intenta de nuevo.'
            );
            if (typeof window.dataLayer != 'undefined') {
              window.dataLayer.push({
                event: 'payment_attempt',
                event_category: 'Ecommerce',
                event_label: 'Error al iniciar autenticación 3DS',
                payment_method: 'online',
              });
            }
            return reject(void 0);
          }
          return resolve(void 0);
        }

        // Only proceed with order if payment is approved
        if (response.data.status !== 'approved') {
          setError_message(
            'El pago no fue aprobado. Por favor intenta de nuevo.'
          );
          logPaymentError(
            `mp_not_approved_${response.data.status || 'unknown'}`,
            'online'
          );
          if (typeof window.dataLayer != 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'payment_attempt',
              event_category: 'Ecommerce',
              event_label: 'El pago no fue aprobado',
              payment_method: 'online',
            });
          }
          return reject(void 0);
        }

        const order_obj = setOrderObject();
        order_obj.mp_payment = {
          authorization_code: response.data.authorization_code,
          card: response.data.card.last_four_digits,
        };
        order_obj.meses = response.data.installments;
        order_obj.ipgTransactionId = response.data.id;
        onSuccess(false, order_obj);
        return resolve(void 0);
      } catch (error) {
        console.log('orderResume.tsx:307 | error ', error);
        reject(void 0);
      } finally {
        isSubmittingRef.current = false;
      }
    });
  };
  const onError = async (error: any) => {
    // callback called for all Brick error cases
    console.log(error);
  };
  const onReady = async () => {
    console.log('orderResume.tsx:344 | Brick is ready');
  };

  return (
    <div className="row my-5 ">
      <div className="col-md-8">
        <MPCardPayment
          initialization={{
            amount: totals.total,
            payer: {
              email: user.email!,
            },
          }}
          onSubmit={onSubmit}
          onReady={onReady}
          onError={onError}
          locale="es-MX"
        />
      </div>
    </div>
  );
};

export default OrderResume;
